import { Navigate, useSearchParams } from 'react-router-dom';

function StoryUIPage() {
  const [searchParams] = useSearchParams();
  const shellParam = searchParams.get('shell');
  const legacyShell = shellParam === 'expert' ? 'expert-shell' : 'customer-shell';
  const docId = searchParams.get('docId');

  if (docId) {
    return <Navigate to={`/hub/${encodeURIComponent(docId)}?legacy=${legacyShell}`} replace />;
  }

  return <Navigate to={`/hub?legacy=${legacyShell}`} replace />;
}

export default StoryUIPage;
